/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Tooltip } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import Company from '../../../components/Company';
import QuarterlyExcelSummarizedReportSFP from '../../../components/EarlyWarning/SummarizedReport/QuarterlyExcelSummarizedReportSFP';
import QuarterlyExcelSummarizedReportSPLOCI from '../../../components/EarlyWarning/SummarizedReport/QuarterlyExcelSummarizedReportSPLOCI';
import NoData from '../../../components/NoData';
import PrintLayout from '../../../components/Print/PrintLayout';
import c from '../../../constant';
import useStore from '../../../store';
import { getDefaultFilterOptionValue, getFilterOptions } from '../../../utils/ews';
import { mappingKhmerNumber } from '../../../utils/market-development';
import Filter from '../../EarlyWarning/components/ews-quarter-summary-filter';
import { getFilterTitle, getYear } from '../../EarlyWarning/utils';
import SFPSpreadSheetTable from '../../EarlyWarning/components/QuarterlySummarizedFinancialReport/SFPSpreadSheetTable';
import SPLOCISpreadSheetTable from '../../EarlyWarning/components/QuarterlySummarizedFinancialReport/SPLOCISpreadSheetTable';

function SummarizedFinancialStatementReportDM({ industrial = true }) {
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const reportId = urlParams.get('reportId') ?? null;
	const report = urlParams.get('report') ?? null;
	const year = urlParams.get('year') ?? null;
	const quarters = urlParams.get('quarters') ?? null;
	const companyType = urlParams.get('companyType') ?? null;
	const companyId = urlParams.get('companyId') ?? null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [tabIndex, setTabIndex] = useState(0);
	const [exportSFP, setExportSFP] = useState(null);
	const [exportSPLOCI, setExportSPLOCI] = useState(null);

	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [filterOptions, setFilterOptions] = useState([]);
	const [isPermitted, setPermitted] = useState(false);
	const [title, setTitle] = useState(null);
	useEffect(() => setFilterOptions(getFilterOptions({ industrial, user })), [user]);
	useEffect(() => setPermitted(filterOptions?.length > 0), [filterOptions]);
	useEffect(() => setTitle(companyType ? companyType : getDefaultFilterOptionValue({ filterOptions })), [companyType, filterOptions]);

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Market Data',
								path: `/insurance-market-data`,
							},
							{
								name: 'Quarterly Financial Summarized Report',
								path: '#',
							},
						]}
					/>
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb="32px"
						>
							<Flex
								className="hidden-print"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								mb="0px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Quarterly Financial Summarized Report')}
								</Text>
								<Flex>
									{tabIndex === 0 && isPermitted && <QuarterlyExcelSummarizedReportSFP object={exportSFP} mr={2} />}
									{tabIndex === 1 && isPermitted && <QuarterlyExcelSummarizedReportSPLOCI object={exportSPLOCI} mr={2} />}
									{isPermitted && (
										<Filter
											industrial={industrial}
											reportId={reportId}
											report={report}
											year={year}
											quarters={quarters}
											companyId={companyId}
											companyType={companyType}
											onCallback={(url) => history.push(`/insurance-market-data/industry-quarterly-summarized-fs-report${url}`)}
										/>
									)}
								</Flex>
							</Flex>
							{isPermitted ? (
								<>
									<Flex flexDirection="column" justifyContent="center" alignItems="center" pt={4} pl={4} pr={4} pb={1}>
										<Text fontSize="xl" fontWeight="700" color="blue.500" mb={1}>
											{t(getFilterTitle({ title, industrial }))}
										</Text>
										{companyId && (
											<Box mb={1}>
												<Company id={companyId} color="blue.500" />
											</Box>
										)}
										<Text fontSize="xl" fontWeight="700" color="blue.500">
											{lang === 'kh' ? mappingKhmerNumber(getYear(year)) : getYear(year)}
										</Text>
									</Flex>
									<Box pt={0} pl={4} pr={4}>
										<Tabs index={tabIndex} onChange={(index) => setTabIndex(index)}>
											<TabList borderBottomWidth="1px" borderBottomStyle="solid" borderBottomColor="gray.200">
												<Tab>
													<Tooltip label={t('SFP')}>
														<Text>{t('sfp')}</Text>
													</Tooltip>
												</Tab>
												<Tab>
													<Tooltip label={t('SPLOCI')}>
														<Text>{t('sploci')}</Text>
													</Tooltip>
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel pl={0} pr={0} pb={0}>
													<SFPSpreadSheetTable
														filterOptions={filterOptions}
														quarters={quarters}
														year={year}
														companyType={companyType}
														companyId={industrial ? null : companyId}
														onReadyForExport={(result) => setExportSFP(result)}
													/>
												</TabPanel>
												<TabPanel pl={0} pr={0} pb={0}>
													<SPLOCISpreadSheetTable
														filterOptions={filterOptions}
														quarters={quarters}
														year={year}
														companyType={companyType}
														companyId={industrial ? null : companyId}
														onReadyForExport={(result) => setExportSPLOCI(result)}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</Box>
								</>
							) : (
								<>
									<NoData />
								</>
							)}
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}

export default SummarizedFinancialStatementReportDM;
